import api from "../utils/api";
import { LOGOUT } from "./types";

export const list = () => async (dispatch) => {
    try {
        const res = await api.get(`/staff/expenses/codes`);
        return res.data?.items || [];
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const save = ({ uuid, code, description, caption, merchant, quantity, each, begins, ends, minimum, maximum }) => async (dispatch) => {
    try {
        const res = await api.post(`/staff/expenses/codes`, { uuid, code, description, caption, merchant, quantity, each, begins, ends, minimum, maximum });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/staff/expenses/codes/i/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const destroy = ( uuid ) => async (dispatch) => {
    try {
        const res = await api.delete(`/staff/expenses/codes/i/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}
